import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { WebPageSchema, BreadcrumbListSchema, OrganizationSchema } from '@/components/feature/SchemaOrg';
import { siteInfo, testimonials, stats } from '@/mocks/home';

export default function AboutPage() {
  const [contactForm, setContactForm] = useState({ name: '', email: '', message: '' });
  const [contactStatus, setContactStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [contactMsg, setContactMsg] = useState('');

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!contactForm.name.trim() || !contactForm.email.trim() || !contactForm.message.trim()) return;

    const honeypotEl = e.currentTarget.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim()) {
      setContactStatus('success');
      setContactMsg('提交成功！我们会尽快与你联系~');
      setContactForm({ name: '', email: '', message: '' });
      return;
    }

    setContactStatus('loading');
    try {
      const formData = new FormData(e.currentTarget);
      const res = await fetch('https://readdy.ai/api/form/d9sn3t94ne17ei0sdkb0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setContactStatus('success');
        setContactMsg('提交成功！我们会尽快与你联系~');
        setContactForm({ name: '', email: '', message: '' });
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } })?.meta?.message || (parsed as { message?: string })?.message || '';
        setContactStatus('error');
        setContactMsg(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setContactStatus('error');
      setContactMsg('网络错误，请稍后再试');
    }
  };

  return (
    <>
      <OrganizationSchema />
      <WebPageSchema
        title="关于我们 - 奶水动漫"
        description="了解奶水动漫的品牌故事、团队理念、平台数据与联系信息。专注母婴哺乳主题动漫内容平台。"
        url="https://www.naishuidongman.com/about"
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://www.naishuidongman.com/' },
          { name: '关于我们' },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <span className="text-foreground-300">/</span>
              <span className="text-foreground-700 font-medium whitespace-nowrap">关于我们</span>
            </nav>

            <div className="text-center mb-12">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-heart-pulse-line text-2xl text-primary-500"></i>
              </div>
              <h1 className="text-2xl md:text-4xl font-heading text-foreground-800 mb-3">关于奶水动漫</h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                奶水动漫是一个专注母婴哺乳主题的动漫内容平台。我们相信，动漫是最温暖、最易于理解的知识传播方式。
                通过生动有趣的漫画和动画，我们帮助每一位新手妈妈轻松掌握哺乳知识，让育儿之路不再孤单。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center py-6 px-4 bg-background-50 rounded-lg">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center">
                    <i className={`${stat.icon} text-2xl text-primary-500`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-heading text-foreground-800 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-8 text-center">我们的故事</h2>
            <div className="space-y-6 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                奶水动漫诞生于一群热爱动漫的妈妈们的心愿。我们中的每一个人都在哺乳育儿的过程中经历过困惑、焦虑和不安。
                信息时代里，网络上充斥着各种哺乳建议，但大多数内容枯燥难懂，甚至相互矛盾。
              </p>
              <p>
                于是，我们萌生了一个想法：为什么不把专业的哺乳知识画成可爱的漫画呢？漫画是跨越年龄和知识背景的语言，
                它能让复杂的医学知识变得亲切易懂。就这样，奶水动漫诞生了。
              </p>
              <p>
                如今，奶水动漫已经汇聚了一支由专业哺乳顾问、儿科医生和优秀漫画师组成的创作团队。
                我们坚持每一篇漫画内容都经过专业审核，确保信息的准确性和科学性。同时，我们也用心打磨每一幅画面，
                让阅读过程充满温暖和治愈。
              </p>
              <p>
                我们的使命很简单：用动漫的力量，让每一位妈妈的哺乳之路更加轻松、更加美好。无论你是正在备孕的准妈妈，
                还是正在哺乳期的新手妈妈，抑或是经验丰富的二宝三宝妈，奶水动漫都欢迎你的到来。
              </p>
              <p>
                未来，我们将继续拓展内容领域，推出更多覆盖孕产全周期的动漫科普内容。让我们一起，用爱和动漫，陪伴每一个宝宝的成长。
              </p>
            </div>
          </div>
        </section>

        <section id="testimonials" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-8 text-center">妈妈口碑</h2>
            <div className="space-y-4">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 border border-background-200/70 rounded-xl p-6 flex gap-4">
                  <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover flex-shrink-0" />
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-sm font-medium text-foreground-700">{t.name}</span>
                      <span className="text-xs text-foreground-400">· {t.babyAge}</span>
                    </div>
                    <div className="flex items-center gap-0.5 mb-2">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-xs text-secondary-500"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-3 text-center">联系我们</h2>
            <p className="text-sm text-foreground-500 text-center mb-10">有任何问题或建议？欢迎随时联系我们！</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">邮箱</div>
                <div className="text-sm font-medium text-foreground-700">{siteInfo.email}</div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-phone-line text-lg text-primary-500"></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">电话</div>
                <div className="text-sm font-medium text-foreground-700">{siteInfo.phone}</div>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-wechat-line text-lg text-primary-500"></i>
                </div>
                <div className="text-xs text-foreground-400 mb-1">微信</div>
                <div className="text-sm font-medium text-foreground-700">{siteInfo.wechat}</div>
              </div>
            </div>

            <form onSubmit={handleContactSubmit} data-readdy-form="" className="bg-background-50 border border-background-200/70 rounded-xl p-6 space-y-4">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="antispam-field"
              />
              <div>
                <label htmlFor="contact-name" className="block text-sm text-foreground-600 mb-1.5">你的名字</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  value={contactForm.name}
                  onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                  required
                  placeholder="请输入你的名字"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm text-foreground-600 mb-1.5">邮箱地址</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  value={contactForm.email}
                  onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                  required
                  placeholder="请输入你的邮箱"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm text-foreground-600 mb-1.5">留言内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  value={contactForm.message}
                  onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="请输入你的留言（最多500字）"
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors resize-none"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">{contactForm.message.length}/500</p>
              </div>
              <button
                type="submit"
                disabled={contactStatus === 'loading'}
                className="w-full py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-sm cursor-pointer disabled:opacity-60"
              >
                {contactStatus === 'loading' ? '提交中...' : '发送留言'}
              </button>
              {contactStatus !== 'idle' && (
                <p className={`text-sm text-center ${contactStatus === 'success' ? 'text-accent-600' : 'text-red-500'}`}>
                  {contactMsg}
                </p>
              )}
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}